import enUS from "./en-us/index.js";

export default {
  "en-us": enUS,
};
